import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm} from 'redux-form'
import FormFieldText from '../../../components/uiKit/FormFieldText'
import Button from '../../../components/uiKit/Button'

const required = value => value ? undefined : 'Sorry but we are going to need you to tell us that'

class ChangePasswordForm extends React.Component{

	render(){

		return(			
				<form onSubmit={this.props.handleSubmit}>

					<Field 
		        		name='currentPassword'
		        		type='password'
		        		label='Your existing password'
				        component={FormFieldText}
				        placeholder=''
				        validate={[required]}
				        autoFocus={true}
				    />

				    <Field 
	        		name='newPassword'	        		
	        		type='password'
	        		label='New Password'
	        		subLabel='Must be at least 6 characters'
			        component={FormFieldText}
			        placeholder=''
			        validate={[required]}
				    />

				 	<div className='accountForm-actionRow'>						      			
      			<Button
      				size='large'
      				submitLoading={this.props.submitLoading}
      				label='Update Password'
      				color={this.props.dirty && this.props.valid ? 'blue' : 'gray'}
      				canSubmit={this.props.dirty && this.props.valid && !this.props.submitLoading ? true : false}
      				type='submit'
      			/>
      		</div>
   		 </form>   		 	
		)
	}
}






ChangePasswordForm = reduxForm({
	form: 'changePasswordForm',
	//onSubmitSuccess: afterSubmit
})(ChangePasswordForm)

export default connect()(ChangePasswordForm)






// WEBPACK FOOTER //
// ./src/components/forms/account/ChangePasswordForm.js